import { Event } from "../Constants";
import { getAuthorization } from './../index';
import { post } from "./Utils";


export const EventActions=({
    Add:(model)=>({url:Event.Add,data:model,...post,headers:{Authorization:`Bearer ${getAuthorization()}`}}),
})